<div class="dash-card">
  <div class="header">
    <h3 class="title">{{ 'DASHBOARD.HEALTH_CHECK' | translate }}</h3>
    <mat-icon
      svgIcon="info-icon-2"
      matTooltip="{{ 'DASHBOARD.HEALTH_CHECK_TOOLTIP' | translate }}"
    ></mat-icon>
  </div>
  <div class="content">
    <svg
      #healthCheckChart
      viewBox="0 0 100 100"
      xmlns="http://www.w3.org/2000/svg"
      preserveAspectRatio="none"
      [attr.data-value]="completionScore"
    >
      <circle r="42.5" cx="50" cy="50" />
      <path
        class="meter"
        d="M7.5,50a42.5,42.5 0 1,0 85,0a42.5,42.5 0 1,0 -85,0"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <text
        x="50"
        y="50"
        text-anchor="middle"
        dominant-baseline="central"
        font-size="20"
        class="notranslate"
      >
        {{ 0 | numberTranslate }}%
      </text>
    </svg>
    <p>{{ 'DASHBOARD.TOTAL_COMPLETION_SCORE' | translate }}</p>
  </div>
</div>
